var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/connection/Caregiver/CaregiverInvitation/index.tsx";
import React, { useEffect, useState } from 'react';
import { Divider, LoadingSpinner, Stack, Text, VStack } from '@adc/parallax-component-library';
import { IconValidationValid } from '@adc/parallax-icons';
import { ApiStatus } from 'Enums';
import { useApiError, useCaregiver, useToast } from 'Hooks';
import { Link, Main, RichText, Spinner, TitleActionBar } from 'Components/utility';
import { SHOW_MODAL } from 'Reducers/modal/types';
import { cutString } from 'Utilities/dataHelpers';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { logout } from 'Utilities/session';
import { store } from 'Utilities/store';
const CaregiverInvitation = ({
  data: {
    caregiverInvitation
  }
}) => {
  const [footerLoading, setFooterLoading] = useState(false);
  const [mainLoading, setMainLoading] = useState(true);
  const {
    showToast
  } = useToast();
  const {
    showApiErrorModal
  } = useApiError();
  const {
    resendCaregiverInvite,
    removeCaregiverInvitation,
    showRemoveInvitationConfirmationModal
  } = useCaregiver();
  useEffect(() => {
    if (!caregiverInvitation) {
      mediator.publish('router:navigate', '/connections');
    }
    setMainLoading(false);
  }, [caregiverInvitation]);
  const onResendInvitation = async () => {
    try {
      setFooterLoading(true);
      await resendCaregiverInvite(caregiverInvitation);
      showToast({
        message: i18n.t('Connections.modals.invitationSentToast.body'),
        'aria-label': i18n.t('Connections.modals.invitationSentToast.body'),
        icon: /*#__PURE__*/React.createElement(IconValidationValid, {
          color: "$support.positive.default",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 54,
            columnNumber: 15
          }
        })
      });
    } catch (err) {
      const error = err;
      if (error.status === ApiStatus.UNAUTHORIZED) {
        logout();
        return;
      }
      if (error.status === ApiStatus.TOO_MANY_REQUESTS) {
        store.dispatch({
          type: SHOW_MODAL,
          modalProps: {
            details: /*#__PURE__*/React.createElement(RichText, {
              text: i18n.t('Connections.modals.invitationLimitDialog.body'),
              testID: "Connections.modals.invitationLimitDialog.body",
              __self: this,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 69,
                columnNumber: 15
              }
            }),
            testID: 'InvitationLimitDialog'
          }
        });
        return;
      }
      showApiErrorModal();
    } finally {
      setFooterLoading(false);
    }
  };
  const onRemoveInvitation = async () => {
    showRemoveInvitationConfirmationModal(async () => {
      try {
        setFooterLoading(true);
        await removeCaregiverInvitation(caregiverInvitation);
        showToast({
          message: i18n.t('Global.modals.removeConnection.connectionRemoved'),
          'aria-label': i18n.t('Global.modals.removeConnection.connectionRemoved')
        });
        mediator.publish('router:navigate', '/connections');
      } catch (err) {
        const error = err;
        if (error.status === ApiStatus.UNAUTHORIZED) {
          logout();
          return;
        }
        showApiErrorModal();
      } finally {
        setFooterLoading(false);
      }
    });
  };
  if (mainLoading) {
    return /*#__PURE__*/React.createElement(Spinner, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 112,
        columnNumber: 12
      }
    });
  }
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 116,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(TitleActionBar, {
    testID: "PendingConnection",
    title: `${cutString(caregiverInvitation.firstName, 10)} ${cutString(caregiverInvitation.lastName, 10)}`,
    closeBtn: true,
    onBack: () => mediator.publish('router:navigate', '/connections'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 117,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Stack, {
    margin: "$4",
    padding: "$4",
    backgroundColor: "$surface.container",
    border: "$1.5",
    shadow: "$-1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 126,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "PendingConnection.title",
    color: "$text.100",
    fontWeight: "$h3.strong",
    fontSize: "$h3.strong",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 133,
      columnNumber: 9
    }
  }, i18n.t('Connections.content.pendingConnection.primaryText')), /*#__PURE__*/React.createElement(Text, {
    testID: "PendingConnection.bodyText",
    marginTop: "$2",
    color: "$text.100",
    fontWeight: "$bodyBase.default",
    fontSize: "$bodyBase.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 141,
      columnNumber: 9
    }
  }, i18n.t('Connections.content.pendingConnection.bodyText')), /*#__PURE__*/React.createElement(Text, {
    testID: "PendingConnection.email-label",
    marginTop: "$8",
    color: "$text.60",
    fontWeight: "$bodySmall.default",
    fontSize: "$bodySmall.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 150,
      columnNumber: 9
    }
  }, i18n.t('Connections.content.pendingConnection.secondaryText')), /*#__PURE__*/React.createElement(Text, {
    testID: "PendingConnection.email",
    color: "$text.100",
    fontWeight: "$bodyBase.medium",
    fontSize: "$bodyBase.medium",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 159,
      columnNumber: 9
    }
  }, caregiverInvitation.email), /*#__PURE__*/React.createElement(Divider, {
    marginVertical: "$4",
    borderColor: "$neutral.40",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 167,
      columnNumber: 9
    }
  }), footerLoading ? /*#__PURE__*/React.createElement(Stack, {
    width: "100%",
    display: "flex",
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 169,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(LoadingSpinner, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 170,
      columnNumber: 13
    }
  })) : /*#__PURE__*/React.createElement(VStack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 173,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Link, {
    testID: "PendingConnection.resendInvitation-btn",
    onPress: onResendInvitation,
    style: {
      marginBottom: 32
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 174,
      columnNumber: 13
    }
  }, i18n.t('Connections.content.pendingConnection.links.resendInvitation.label')), /*#__PURE__*/React.createElement(Link, {
    testID: "PendingConnection.remove-btn",
    onPress: onRemoveInvitation,
    linkTextColor: "$support.danger.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 181,
      columnNumber: 13
    }
  }, i18n.t('Global.microcopy.common.removeCap')))));
};
export default CaregiverInvitation;